/**
 * 烘干厂仓位 API.
 * 后端: /hl-drying/drying/warearea/**
 * 实体字段: { id, factoryId, name, kind('grain'|'input'), capacity, enabled('1'|'0'), remark }
 */
import request from '@/utils/request'
import { depsCached, depsKey, depsInvalidate } from '@/utils/depsCache'

const CACHE_PREFIX = 'wareareas:'

/** 列出某厂仓位 (kind 可选: grain / input / undefined=全部) */
export function listWareareas(factoryId, kind) {
  const params = { factoryId }
  if (kind) params.kind = kind
  return request.get('/hl-drying/drying/warearea/list', { params })
}

/** [2026-10-08 性能] 带缓存读 (60s TTL): 业务页仓位下拉用, 本文件写操作自动失效.
 *  ⚠️ 入库/出库"免选仓位"由后端自动建「{品种}默认仓」(不走前端 saveWarearea, 失效覆盖不到) —
 *  提交单据后的仓位补拉 (让新默认仓出现在下一单下拉) 必须先 invalidateWareareas() 再拉. */
export function listWareareasCached(factoryId, kind) {
  const params = { factoryId }
  if (kind) params.kind = kind
  return depsCached(depsKey(CACHE_PREFIX, params), () => listWareareas(factoryId, kind))
}

/** 清空仓位缓存 — 后端自动建仓旁路 (免选仓位提交) 的配套失效入口 */
export function invalidateWareareas() {
  depsInvalidate(CACHE_PREFIX)
}

/** 新增 / 编辑 (有 id 则编辑) */
export async function saveWarearea(data) {
  const r = await request.post('/hl-drying/drying/warearea/save', data)
  depsInvalidate(CACHE_PREFIX)
  return r
}

/** 启停切换 */
export async function toggleWarearea(id, factoryId) {
  const r = await request.post('/hl-drying/drying/warearea/toggle', null, { params: { id, factoryId } })
  depsInvalidate(CACHE_PREFIX)
  return r
}

/** 删除 (有库存禁止删) */
export async function deleteWarearea(id, factoryId) {
  const r = await request.post('/hl-drying/drying/warearea/delete', null, { params: { id, factoryId } })
  depsInvalidate(CACHE_PREFIX)
  return r
}
